import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { AccountStatus, AdminRole } from 'interfaces';

export type Admin = {
  admin_id?: number; // 관리자 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  admin_account?: string; // ID
  password?: string; // Password
  admin_phone?: string; // 관리자 연락처
  admin_email?: string; // 관리자 이메일
  admin_name?: string; // 관리자 명
  admin_position?: string; // 관리자 직책
  admin_level?: number; // 관리자 권한 레벨
  admin_privilege?: string; // 관리자 권한
  type?: (typeof AdminRole)[keyof typeof AdminRole]; // 타입 (관리자/쇼핑몰관리자/매장관리자)
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  access_time?: number; // 접속이력
  withdrawal_time?: number; // 탈퇴일
  account_status?: (typeof AccountStatus)[keyof typeof AccountStatus]; // 계정상태
  pw_change_time?: number; // 비밀번호 변경일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Admin
   * --
   */
  getAdmins: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_ADMIN, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Admin
   * --
   */
  getAdmin: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_ADMIN, { admin_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Admin
   * --
   */
  createAdmin: async (body: Admin) => {
    try {
      const res = await $http.post(APIConstant.CREATE_ADMIN, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Admin
   * --
   */
  updateAdmin: async (body: Admin) => {
    try {
      const { admin_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_ADMIN, {
        admin_id: admin_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Admin
   * --
   */
  deleteAdmin: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_ADMIN, {
        admin_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
